import { render, staticRenderFns } from "./AudioPlayback.vue?vue&type=template&id=6bc39f4c&scoped=true"
import script from "./AudioPlayback.vue?vue&type=script&lang=js"
export * from "./AudioPlayback.vue?vue&type=script&lang=js"
import style0 from "./AudioPlayback.vue?vue&type=style&index=0&id=6bc39f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc39f4c",
  null
  
)

export default component.exports